import React, { useState } from "react";

function NewarkShowHide() {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleText = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div>
      <div className="junk-santa">
        <h3>Serving Newark, CA and Surrounding Areas</h3>
        <div className="sliderline-svg">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="4"
            viewBox="0 0 64 4"
            fill="none"
          >
            <path
              d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
              fill="#60BDFF"
            ></path>
          </svg>
        </div>
      </div>

      <div className="junk-santa-desc">
        <p>
          At Junk Droid, we serve the entire Newark area and surrounding cities,
          including Fremont, Hayward, Milpitas, and more. Whether it’s a single
          item or a full junk removal job, we’re here to help you reclaim your
          space.
        </p>
      </div>

      {isExpanded && (
        <div>
          <div className="pt-0 junk-santa-desc milpitas-list">
            <h3>Get Your Free Quote for Junk Removal in Newark, CA</h3>
            <div className="sliderline-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="64"
                height="4"
                viewBox="0 0 64 4"
                fill="none"
              >
                <path
                  d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                  fill="#60BDFF"
                ></path>
              </svg>
            </div>
            <p>
              Ready to clear out your space? Junk Droid is here to help with
              junk removal in Newark, CA. Contact us today for a free quote or
              to schedule a same-day service. We’ll provide you with an upfront,
              reasonable price and a seamless junk removal experience.
            </p>
            <h3>Contact Junk Droid for Junk Removal in Newark, CA</h3>
            <div className="sliderline-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="64"
                height="4"
                viewBox="0 0 64 4"
                fill="none"
              >
                <path
                  d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                  fill="#60BDFF"
                ></path>
              </svg>
            </div>
            <p>
              Call <a href="tel:+4085397261">(408) 539-7261</a> or book your
              appointment online for reliable and professional junk removal
              services in Newark, California. Whether it’s furniture removal,
              construction debris, or a complete cleanout, our team is ready to
              handle your junk removal project.
            </p>
          </div>
        </div>
      )}

      <button className="btn btn-read" onClick={toggleText}>
        {isExpanded ? "Read Less" : "Read More"}
      </button>
    </div>
  );
}

export default NewarkShowHide;
